import { render, staticRenderFns } from "./HouseKeepingForm.vue?vue&type=template&id=671ff04d"
import script from "./HouseKeepingForm.vue?vue&type=script&lang=js"
export * from "./HouseKeepingForm.vue?vue&type=script&lang=js"
import style0 from "./HouseKeepingForm.vue?vue&type=style&index=0&id=671ff04d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports